import styled from 'styled-components';

export default styled.div`
    margin-bottom: ${({ theme }) => theme.layout.gutter};

    .alert {
        margin-top: ${({ theme }) => theme.layout.gutter};
    }
` as React.ComponentType<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>>;
